import React, { useEffect } from "react";

function ModalMondialRelay({ onClose, onChoose }) {
  // On stocke temporairement la sélection dans une variable globale
  // (solution simple pour la démo ; on pourrait aussi utiliser un state local + un hook).
  window.selectedRelayData = null;

  useEffect(() => {
    // 1. Charger jQuery si non présent
    const jqueryScript = document.createElement("script");
    jqueryScript.src = "https://ajax.googleapis.com/ajax/libs/jquery/2.2.4/jquery.min.js";
    jqueryScript.async = true;
    document.body.appendChild(jqueryScript);

    // 2. Charger Leaflet (CSS + JS) pour la carte
    const leafletCSS = document.createElement("link");
    leafletCSS.rel = "stylesheet";
    leafletCSS.href = "https://unpkg.com/leaflet/dist/leaflet.css";
    document.head.appendChild(leafletCSS);

    const leafletScript = document.createElement("script");
    leafletScript.src = "https://unpkg.com/leaflet/dist/leaflet.js";
    leafletScript.async = true;
    document.body.appendChild(leafletScript);

    // 3. Charger le script du widget Mondial Relay
    const widgetScript = document.createElement("script");
    widgetScript.src =
      "https://widget.mondialrelay.com/parcelshop-picker/jquery.plugin.mondialrelay.parcelshoppicker.min.js";
    widgetScript.async = true;
    widgetScript.onload = () => {
      // Petit délai pour s'assurer que tout est chargé (jQuery, Leaflet)
      setTimeout(() => {
        if (window.$ && window.$("#Zone_Widget").MR_ParcelShopPicker) {
          window.$("#Zone_Widget").MR_ParcelShopPicker({
            Brand: "CC23GIF2",         // Ton code client Mondial Relay (8 caractères)
            Target: "#Target_Widget",  // Champ où l’ID du relais sera écrit
            Country: "FR",
            PostCode: "75001",         // Code postal par défaut
            ColLivMod: "24R",          // Mode de livraison
            NbResults: "7",
            Responsive: true,
            ShowResultsOnMap: true,

            // Callback appelé lorsque l'utilisateur sélectionne un relais
            OnParcelShopSelected: function (data) {
              // data contient les infos sur le relais sélectionné
              // On le stocke dans une variable globale pour le récupérer plus tard
              window.selectedRelayData = data;
              // On met aussi l'ID dans l'input caché
              window.$("#Target_Widget").val(data.ID);
            }
          });
        }
      }, 500);
    };
    document.body.appendChild(widgetScript);

    // Nettoyage : enlever les scripts quand la modale se démonte
    return () => {
      document.body.removeChild(jqueryScript);
      document.head.removeChild(leafletCSS);
      document.body.removeChild(leafletScript);
      document.body.removeChild(widgetScript);
    };
  }, []);

  // Quand on clique sur "CHOISIR CE POINT RELAIS"
  const handleChoosePoint = () => {
    // Récupérer les données stockées dans la variable globale
    const data = window.selectedRelayData;
    if (data && onChoose) {
      // Remonter les infos au parent
      onChoose(data);
    }
    // Fermer la modale
    onClose();
  };

  return (
    <div style={modalStyles.overlay}>
      <div style={modalStyles.modal}>
        <button style={modalStyles.closeButton} onClick={onClose}>
          Fermer
        </button>

        {/* Zone où s'affichera la liste + carte Mondial Relay */}
        <div id="Zone_Widget" style={{ marginTop: "1rem" }}></div>

        {/* Input caché où l'ID du point relais est écrit (optionnel) */}
        <input type="hidden" id="Target_Widget" name="Target_Widget" />

        {/* Bouton pour valider le choix du point relais */}
        <button style={modalStyles.chooseButton} onClick={handleChoosePoint}>
          CHOISIR CE POINT RELAIS
        </button>
      </div>
    </div>
  );
}

// Styles inline simples (tu peux déplacer ça dans un .css)
const modalStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    background: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 999
  },
  modal: {
    background: "#fff",
    padding: "16px",
    borderRadius: "8px",
    maxWidth: "600px",
    width: "90%",
    position: "relative"
  },
  closeButton: {
    position: "absolute",
    top: "8px",
    right: "8px",
    border: "none",
    background: "transparent",
    fontSize: "1.2rem",
    cursor: "pointer"
  },
  chooseButton: {
    marginTop: "1rem",
    background: "#000",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    padding: "10px 16px",
    cursor: "pointer"
  }
};

export default ModalMondialRelay;
